/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SearchPublishedDateOrderPressReleaseResponseData,
    SearchPublishedDateOrderPressReleaseResponseDataFromJSON,
    SearchPublishedDateOrderPressReleaseResponseDataFromJSONTyped,
    SearchPublishedDateOrderPressReleaseResponseDataToJSON,
} from './SearchPublishedDateOrderPressReleaseResponseData';

/**
 * 
 * @export
 * @interface SearchPublishedDateOrderPressReleaseResponse
 */
export interface SearchPublishedDateOrderPressReleaseResponse {
    /**
     * 
     * @type {number}
     * @memberof SearchPublishedDateOrderPressReleaseResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof SearchPublishedDateOrderPressReleaseResponse
     */
    message: string;
    /**
     * 
     * @type {SearchPublishedDateOrderPressReleaseResponseData}
     * @memberof SearchPublishedDateOrderPressReleaseResponse
     */
    data: SearchPublishedDateOrderPressReleaseResponseData;
}

export function SearchPublishedDateOrderPressReleaseResponseFromJSON(json: any): SearchPublishedDateOrderPressReleaseResponse {
    return SearchPublishedDateOrderPressReleaseResponseFromJSONTyped(json, false);
}

export function SearchPublishedDateOrderPressReleaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchPublishedDateOrderPressReleaseResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': SearchPublishedDateOrderPressReleaseResponseDataFromJSON(json['data']),
    };
}

export function SearchPublishedDateOrderPressReleaseResponseToJSON(value?: SearchPublishedDateOrderPressReleaseResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': SearchPublishedDateOrderPressReleaseResponseDataToJSON(value.data),
    };
}

